import React from 'react';
import { ILinkProps, Link } from '@fluentui/react';
import { useFluentTheme } from '@theme/index';
import getStyles from './Link.styles';

export enum LinkVariants {
  Default = 'Default',
  Secondary = 'Secondary',
}

type ButtonProps = ILinkProps & {
  variant?: LinkVariants;
  className?: string;
  children: React.ReactNode;
};

const Button: React.FunctionComponent<ButtonProps> = ({
  variant = LinkVariants.Default,
  className = '',
  children,
  ...restProps
}: ButtonProps) => {
  const theme = useFluentTheme();
  const styles = getStyles(theme);
  if (variant === LinkVariants.Secondary)
    return <Link className={`${styles.secondaryLink} ${className}`} {...restProps}>{children}</Link>;
  return <Link className={`${styles.defaultLink} ${className}`} {...restProps}>{children}</Link>;
};
export default Button;
